import { jsxs, jsx } from "react/jsx-runtime";
const IconGiftSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M15 5.833h-.292c.19-.389.29-.816.292-1.25a2.909 2.909 0 0 0-5-2.033 2.908 2.908 0 0 0-5 2.033c.002.434.101.861.292 1.25H5a2.5 2.5 0 0 0-2.5 2.5V10a.833.833 0 0 0 .833.833h.834v5a2.5 2.5 0 0 0 2.5 2.5h6.666a2.5 2.5 0 0 0 2.5-2.5v-5h.834A.833.833 0 0 0 17.5 10V8.333a2.5 2.5 0 0 0-2.5-2.5ZM9.167 16.667h-2.5a.833.833 0 0 1-.834-.834v-5h3.334v5.834Zm0-7.5h-5v-.834A.833.833 0 0 1 5 7.5h4.167v1.667Zm0-3.334h-1.25a1.25 1.25 0 1 1 1.25-1.25v1.25Zm1.666-1.25a1.25 1.25 0 1 1 1.25 1.25h-1.25v-1.25Zm3.334 11.25a.833.833 0 0 1-.834.834h-2.5v-5.834h3.334v5Zm1.666-6.666h-5V7.5H15a.833.833 0 0 1 .833.833v.834Z" })
    ]
  }
);
export {
  IconGiftSvg
};
